export const getSliderOffset = (
  $items: ZeptoCollection,
  position: number,
  containerWidth: number
): {
  offsetX: number
  hasLeftHiddenItems: boolean
  hasRightHiddenItems: boolean
} => {
  if ($items.length === 0) {
    return {
      offsetX: 0,
      hasLeftHiddenItems: false,
      hasRightHiddenItems: false
    }
  }

  const firstItemOffset = $items.eq(0).offset()
  const secondItemOffset = $items.eq(1).offset()
  const itemWidth = secondItemOffset.left - firstItemOffset.left
  const itemGap = itemWidth - firstItemOffset.width
  const positionX = itemWidth * position
  const contentWidth = $items.length * itemWidth - itemGap

  const maxOffsetX = contentWidth - containerWidth
  let offsetX = positionX

  if (positionX < 0 || contentWidth <= containerWidth) {
    offsetX = 0
  } else if (positionX > maxOffsetX) {
    offsetX = maxOffsetX
  } else if (positionX % itemWidth > 0) {
    offsetX = positionX + itemWidth - (positionX % itemWidth)
  }

  return {
    offsetX,
    hasLeftHiddenItems: offsetX > 0,
    hasRightHiddenItems: offsetX < maxOffsetX && contentWidth > containerWidth
  }
}
